export default "__VITE_ASSET__b5ee9696__"